import { defineStore } from 'pinia';
import { reactive } from 'vue';

export const useFunctionalitiesStore = defineStore('functionalities', () => {
  const state = reactive({
    content: [],
    contentToShow: 10,
    user: false,
  });

  function setContentToShow(payload) {
    state.content = payload.allData.slice(payload.currentPage * state.contentToShow - state.contentToShow, payload.currentPage * state.contentToShow);
  }

  function setUser(payload) {
    state.user = payload.user;
    localStorage.setItem('user', payload.user);
  }

  function logoutUser() {
    state.user = false;
    localStorage.removeItem('user');
  }

  function calculatePages(payload) {
    const pages = [];
    const startPage = payload.currentPage === 1 ? payload.currentPage : payload.currentPage - 1;
    const endPage = payload.currentPage === 1 ? payload.currentPage + 2 : payload.currentPage + 1 <= payload.totalPages ? payload.currentPage + 1 : payload.currentPage;

    for (let i = startPage; i <= endPage; i++) {
      if (i <= payload.totalPages) pages.push(i);
    }
    return pages;
  }

  function changePage(payload) {
    if (payload.toPage <= payload.totalPages && payload.toPage > 0) {
      payload.currentPage = payload.toPage;
    } else {
      payload.toPage = payload.currentPage;
    }

    setContentToShow(payload);
    return [...calculatePages(payload)];
  }

  return {
    state,
    setContentToShow,
    setUser,
    logoutUser,
    changePage,
  };
});
